<template>
<div class="top-nav-container" :style="{ marginTop: isIE ? '40px' : 0 }">
  <div class="main-1 clearfix">
    <div class="logo left">
      <img src="~assets/logo.jpg" alt="logo" />
      <span></span>
    </div>
    <div class="page-nav left">
      <nuxt-link v-for="item of navList" :key="item.path" :to="item.path" :exact="item.path === '/'">{{ item.title }}</nuxt-link>
    </div>
    <!-- <div class="search right">
      <input v-model.trim="keyword" @keydown.enter="search" placeholder="输入老师名..." /><i @click="search" class="iconfont icon-ss center"></i>
    </div> -->
  </div>
</div>
</template>

<script>
export default {
  data () {
    return {
      // 默认菜单（全国通用）
      defaultNavList: [
        { title: '首页', path: '/' },
        { title: '互动', path: '/room' },
        { title: '问答', path: '/question' },
        { title: '文章', path: '/article' },
        { title: '我的', path: '/user' },
        { title: '关于', path: '/about' },
      ],
      // 杭州专属菜单
      hangzhouNavList: [
        { title: '首页', path: '/' },
        { title: '商务合作', path: '/vertically' },
        { title: '信息咨讯', path: '/news' },
        { title: '招贤纳士', path: '/join' },
        { title: '我的', path: '/user' },
        { title: '关于', path: '/about' },
      ],
      navList: [], // 动态菜单
      keyword: '',
      unread: '',
      isIE: false
    }
  },
  async mounted () {
    // position: sticky 不适用IE
    this.isIE = /Trident/.test(navigator.userAgent)
    
    // 初始化菜单
    await this.initNavMenu()
  },
  methods: {
    // 初始化导航菜单
    async initNavMenu() {
      // 1. 先检查缓存（避免重复请求）
      const cachedCity = localStorage.getItem('user_city')
      const cacheTime = localStorage.getItem('user_city_time')
      const isCacheValid = cachedCity && cacheTime && (Date.now() - cacheTime < 30 * 60 * 1000) // 30分钟缓存
      
      let city = null
      
      if (isCacheValid) {
        // 使用缓存的城市
        city = cachedCity
        // console.log('使用缓存的城市：', city)
      } else {
        // 2. 请求接口获取城市
        try {
          const res = await this.$axios.get('/Common/IpCity')
          console.log('接口返回数据：', res)
          
          // 关键修复：res 是响应对象，需要取 res.data
          city = res.data || res // 兼容不同的返回格式
          // console.log('解析后的城市：', city)
          
          // 3. 缓存城市信息
          if (city) {
            localStorage.setItem('user_city', city)
            localStorage.setItem('user_city_time', Date.now())
          }
        } catch (error) {
          // console.error('获取城市失败：', error)
          city = null
        }
      }
      
      // 4. 根据城市设置菜单
      if (city === '杭州') {
        this.navList = this.hangzhouNavList
        // console.log('杭州用户，显示定制菜单')
      } else {
        this.navList = this.defaultNavList
        // console.log('非杭州用户，显示默认菜单')
      }
    },
    
    search () {
      if (this.keyword !== '') {
        this.$router.push({ path: '/search', query: { keyword: this.keyword } })
        this.keyword = ''
      }
    }
  }
}
</script>

<style lang="less">
.top-nav-container {
  background: #e43a3d;
  .logo {
    img {
      width: 120px; height: 43px; display: inline-block; margin: 24px 100px 0 0;
    }
  }
  .page-nav {
    overflow: hidden;
    a {
      float: left; line-height: 90px; width: 80px; font-size: 16px; color: #fff; text-align: center;
      &:hover:not(.nuxt-link-active) { background: rgba(198, 20, 32, .4); }
      &.nuxt-link-active { background: #C61420; font-weight: bold; }
    }
  }
  .search {
    overflow: hidden; background: #FFFFFF; border-radius: 4px; margin-top: 25px;
    input {
      float: left; outline: none; height: 40px; width: 200px; border: none; text-indent: 10px;
    }
    i {
      float: left; width: 40px; height: 40px; cursor: pointer; font-size: 22px; padding-top: 9px; color: #999;
    }
  }
}
</style>